module.exports = __webpack_public_path__ + "media/images/info-down-913392f4ea76b09641b050d9f98ff969.png";